// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Qp-z","slideIn":"Rp-z"};